module.exports = __webpack_public_path__ + "img/ico-trash-blue.b3188c97.svg";